// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3en4z","buttons":"RemoveExpirationActionButtons_buttons__1F_PB"};